
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "axios";
import FileUpload from "../../components/common/FileUpload";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Loader from "../../components/common/Loader";
import Badge from "@mui/material/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMagnifyingGlass,
  faUserGraduate,
  faEnvelope,
  faUserCheck,
  faIdBadge,
  faFileSignature,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";
import SecCard from "../../components/common/SecCard";
import { green, yellow, red } from "@mui/material/colors";
import { SERVER_ORIGIN, validation } from "../../utilities/constants";
import HeaderCard from "../../components/common/HeaderCard";
import AsyncSelect from "react-select/async";
import css from "../../css/admin/users-page.module.css";
import DownloadExcel from "../../components/common/DownloadExcel";
import YuvaEcAssignmentModal from "../../components/common/YuvaEcAssignmentModal";
import BackButton from "../../components/common/BackButton";
import {
  hasReadOnlyAccess,
  getManageInstitutePath,
} from "../../utilities/helper_functions";
// import { IconButton } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
const InstutueStudents = () => {
  const { _id } = useParams();
  const [searchParams] = useSearchParams();
  const yuvaEcOnly = searchParams.get("yuvaEcOnly") === "1";
  const [activeTab, setActiveTab] = useState("institute");
  const [instituteType, setInstituteType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(0);
  const [allUsers, setAllUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isInviteAllowed, setIsInviteAllowed] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [showEcModal, setShowEcModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [rerender, setRerender] = useState(true);
  const [userType, setUserType] = useState(sessionStorage.getItem("userType") || "unknown");
  console.log("userTypeuserTypeuserType:", userType);
  const navigate = useNavigate();
  const isReadOnly = hasReadOnlyAccess();

  // Statistics state
  const [stats, setStats] = useState({
    total: 0,
    onboarded: 0,
    invited: 0,
    pending: 0,
    emailSent: 0,
    emailNotSent: 0,
    yuvaEC: 0,
    publicRegistration: 0,
    regularRegistration: 0,
  });
  const [uploadedDataStudentsCount, setUploadedDataStudentsCount] = useState(0);

// Inside the component, add state
const [anchorEl, setAnchorEl] = useState(null);
const [selectedRow, setSelectedRow] = useState(null);

const handleMenuOpen = (event, row) => {
  setAnchorEl(event.currentTarget);
  setSelectedRow(row);
};

const handleMenuClose = () => {
  setAnchorEl(null);
  setSelectedRow(null);
};

  // Debounce search input
  useEffect(() => {
    const handle = setTimeout(
      () => setDebouncedSearch(searchQuery.trim()),
      350
    );
    return () => clearTimeout(handle);
  }, [searchQuery]);

  useEffect(() => {
    const checkTermsStatus = async () => {
      try {
        const response = await fetch(
          `${SERVER_ORIGIN}/api/institute/auth/check-terms`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
            body: JSON.stringify({ _id: _id }),
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        const isThalir = result.data.isThalir || false;
        setInstituteType(isThalir ? "thalir" : "institute");
        setActiveTab(isThalir ? "thalir" : "institute");

        if (
          result.data.termsAccepted === true &&
          result.data.onboardingSatus === "onboarded"
        ) {
          setIsInviteAllowed(true);
        }
      } catch (error) {
        console.error("Error fetching Terms status:", error);
      }
    };

    const getInstituteDetails = async () => {
      try {
        const response = await fetch(
          `${SERVER_ORIGIN}/api/institute/auth/users/${_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        if (response.ok) {
          const result = await response.json();
          const isThalir = result.user?.isThalir || false;
          setInstituteType(isThalir ? "thalir" : "institute");
          setActiveTab(isThalir ? "thalir" : "institute");
        }
      } catch (error) {
        console.error("Error fetching institute details:", error);
      }
    };

    checkTermsStatus();
    getInstituteDetails();
  }, [_id]);

  // Calculate statistics from user data
  const calculateStatistics = (users) => {
    const total = users.length;
    const onboarded = users.filter(
      (user) => user.onboardingSatus === "onboarded"
    ).length;
    const invited = users.filter(
      (user) => user.onboardingSatus === "invited"
    ).length;
    const pending = users.filter(
      (user) => user.onboardingSatus === "pending"
    ).length;
    const emailSent = users.filter(
      (user) => user.emailSentStatus === "sent"
    ).length;
    const emailNotSent = users.filter(
      (user) => user.emailSentStatus === "not sent"
    ).length;
    const yuvaEC = users.filter((user) => user.isYuvaEC === true).length;
    const publicRegistration = users.filter(
      (user) => user.isPublicRegistration === true
    ).length;
    const regularRegistration = total - publicRegistration;

    return {
      total,
      onboarded,
      invited,
      pending,
      emailSent,
      emailNotSent,
      yuvaEC,
      publicRegistration,
      regularRegistration,
    };
  };

  useEffect(() => {
    async function getAllUsers() {
      setIsLoading(true);

      try {
        const response = await fetch(
          `${SERVER_ORIGIN}/api/institute/auth/users/all?page=${page}&limit=${limit}&search=${debouncedSearch}&sortBy=fName&sortType=${sortType === true ? "asc" : "desc"
          }`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
            body: JSON.stringify({
              _id: _id, collegeName: selectedOption?.label || ""
            }),
          }
        );

        const result = await response.json();
        setIsLoading(false);

        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate("/admin/login");
          } else if (response.status === 500) {
            toast.error(result.statusText);
          }
        } else if (response.ok && response.status === 200) {
          setAllUsers(result.filteredUsers);
          setTotalPages(result.totalPages);
          setUploadedDataStudentsCount(result.uploadedDataStudentsCount ?? 0);
          // Calculate statistics
          setStats(calculateStatistics(result.filteredUsers));
        }
      } catch (err) {
        setIsLoading(false);
      }
    }

    const fetchDefaultOptions = async () => {
      try {
        const response = await axios.get(
          `${SERVER_ORIGIN}/api/institute/auth/institute/all`,
          {
            params: {
              search: "",
              page: 1,
              limit: 5,
              sortBy: "name",
              sortType: "asc",
              id: _id,
            },
          }
        );
        const options = response.data.filteredInstitutes.map((institute) => ({
          label: institute.name,
          value: institute._id,
          state: institute.state,
          city: institute.city,
        }));
        setDefaultOptions(options);
      } catch (error) {
        console.error("Error fetching default options", error);
      }
    };

    fetchDefaultOptions();
    getAllUsers();
  }, [page, sortType, debouncedSearch, navigate, limit, _id, rerender]);

  const displayUsers = useMemo(() => {
    if (!yuvaEcOnly) return allUsers;
    return (allUsers || []).filter((u) => u?.isYuvaEC === true);
  }, [allUsers, yuvaEcOnly]);

  const renderOnboardingStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "invited":
        statusColor = yellow[500];
        statusText = "Invited";
        textColor = "black";
        break;
      case "pending":
        statusColor = red[500];
        statusText = "Pending";
        textColor = "white";
        break;
      case "onboarded":
        statusColor = green[500];
        statusText = "Onboarded";
        textColor = "white";
        break;
      default:
        statusColor = "transparent";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            borderRadius: "8px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  const renderEmailStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "sent":
        statusColor = green[500];
        statusText = "Sent";
        textColor = "white";
        break;
      case "not sent":
        statusColor = red[500];
        statusText = "Not Sent";
        textColor = "white";
        break;
      default:
        statusColor = "transparent";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            borderRadius: "8px",
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      align: "center",
      width: 80,
    },
    {
      field: "yuvaStudentId",
      headerName: "Student ID",
      align: "center",
      width: 160,
      valueGetter: (params) => params.row.yuvaStudentId || "-",
    },
    {
      field: "fName",
      align: "center",
      headerName: "Full Name",
      width: 170,
      valueGetter: (params) =>
        `${params.row.fName || ""} ${params.row.lName || ""}`.trim(),
    },
    // {
    //   field: "email",
    //   headerName: "Email",
    //   align: "center",
    //   width: 200,
    // },
    ...(userType !== "em"
      ? [
        {
          field: "email",
          headerName: "Email",
          align: "center",
          width: 200,
        },
        {
          field: "updatedAt",
          headerName: "Last Updated",
          align: "center",
          width: 140,
        },
      ]
      : []),
    // {
    //   field: "collegeName",
    //   headerName: "Institute Name",
    //   align: "center",
    //   width: 170,
    // },
    {
      field: "collegeName",
      headerName: instituteType === "thalir" ? "School Name" : "Institute Name",
      align: "center",
      width: 170,
    },

    {
      field: "passOutYear",
      headerName: "Passout Year",
      align: "center",
      width: 130,
    },
    {
      field: "chapterName",
      headerName: "Chapter Name",
      align: "center",
      width: 150,
    },
    {
      field: "region",
      headerName: "Region",
      align: "center",
      width: 120,
    },
    {
      field: "onboardingSatus",
      headerName: "Onboarding Status",
      width: 150,
      align: "center",
      renderCell: renderOnboardingStatus,
    },
    // {
    //   field: "updatedAt",
    //   headerName: "Last Updated",
    //   align: "center",
    //   width: 140,
    //   valueGetter: (params) => params.row.updatedAt || params.row.createdAt || null,
    //   valueFormatter: (params) => {
    //     if (!params.value) return "-";
    //     const d = new Date(params.value);
    //     return d.toLocaleDateString("en-US", {
    //       year: "numeric",
    //       month: "short",
    //       day: "numeric",
    //       hour: "2-digit",
    //       minute: "2-digit",
    //     });
    //   },
    //   renderCell: (params) => (
    //     <span style={{ whiteSpace: "normal", lineHeight: 1.3 }}>
    //       {params.formattedValue || params.value || "-"}
    //     </span>
    //   ),
    // },
    {
      field: "registrationType",
      headerName: "Registration Type",
      align: "center",
      width: 150,
      renderCell: (params) => {
        const isPublic = params.row.isPublicRegistration || false;
        return (
          <Badge>
            <span
              style={{
                backgroundColor: isPublic ? "#007bff" : "#6c757d",
                padding: "4px 8px",
                borderRadius: "6px",
                color: "white",
                fontSize: "11px",
                fontWeight: "500",
              }}
            >
              {isPublic ? "Public Link" : "Regular"}
            </span>
          </Badge>
        );
      },
    },
    ...(activeTab !== "thalir"
      ? [
        {
          field: 'lastLoginDate', headerName: 'Last Login', align: 'center', width: 170, valueGetter: (params) => {
            if (!params.value) return "Never";
            const date = new Date(params.value);
            return date.toLocaleString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            });
          }
        },
        {
          field: "yuvaEcStatus",
          headerName: "YUVA EC Status",
          align: "center",
          width: 150,
          renderCell: (params) => {
            const isEC = params.row.isYuvaEC || false;
            const ecPosition = params.row.yuvaEcPosition || "";

            if (isEC) {
              return (
                <Badge>
                  <span
                    style={{
                      backgroundColor: green[500],
                      padding: "6.4px 16px",
                      borderRadius: "8px",
                      color: "white",
                      fontSize: "12px",
                    }}
                  >
                    {ecPosition || "YUVA EC"}
                  </span>
                </Badge>
              );
            } else {
              return (
                <Badge>
                  <span
                    style={{
                      backgroundColor: "#f5f5f5",
                      padding: "6.4px 16px",
                      borderRadius: "8px",
                      color: "#666",
                      fontSize: "12px",
                    }}
                  >
                    Not Assigned
                  </span>
                </Badge>
              );
            }
          },
        },
    //     {
    //       field: "viewDetails",
    //       headerName: "View Details",
    //       type: "actions",
    //       width: 130,
    //       align: "center",
    //       renderCell: (params) => (
    //         <button
    //           className={css.viewBtn}
    //           onClick={() => navigate(`/admin/users/${params.row.userId}`)}
    //         >
    //           View Details
    //         </button>
    //       ),
    //     },
      ]
      : []),
    // ...(activeTab !== "thalir"
    //   ? [
    //     {
    //       field: "assignEC",
    //       headerName: "Assign YUVA EC",
    //       type: "actions",
    //       width: 150,
    //       align: "center",
    //       renderCell: (params) => (
    //         <button
    //           className={css.editBtn}
    //           style={{
    //             backgroundColor: "#28a745",
    //             border: "none",
    //             color: "white",
    //             padding: "6px 12px",
    //             borderRadius: "4px",
    //             fontSize: "12px",
    //             cursor: "pointer",
    //           }}
    //           onClick={() => {
    //             setSelectedStudent(params.row);
    //             setShowEcModal(true);
    //           }}
    //         >
    //           Assign YUVA EC
    //         </button>
    //       ),
    //     },
    //   ]
    //   : []),
    
    // {
    //   field: "editDetails",
    //   headerName: "Edit",
    //   type: "actions",
    //   width: 100,
    //   align: "center",
    //   renderCell: (params) => (
    //     <button
    //       className={css.viewBtn}
    //       onClick={() =>
    //         navigate(
    //           `/user/register/no_id?edit=true&id=${encodeURIComponent(
    //             params.row.userId
    //           )}?tab=${activeTab}`
    //         )
    //       }
    //     >
    //       Edit
    //     </button>
    //   ),
    // },
    // New Actions column
    {
      field: 'actions',
      headerName: 'Actions',
      type: 'actions',
      width: 100,
      align: 'center',
      renderCell: (params) => (
        <>
          <IconButton
            aria-label="actions"
            onClick={(e) => handleMenuOpen(e, params.row)}
            size="small"
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && selectedRow?.id === params.row.id}
            onClose={handleMenuClose}
          >
            {/* View Details - always shown for institute/thalir? Adjust as needed */}
            <MenuItem
              onClick={() => {
                navigate(`/admin/users/${params.row.userId}`);
                handleMenuClose();
              }}
            >
              View Details
            </MenuItem>

            {/* Assign YUVA EC - only shown for institute and if not read-only */}
            {activeTab !== 'thalir' && !isReadOnly && (
              <MenuItem
                onClick={() => {
                  setSelectedStudent(params.row);
                  setShowEcModal(true);
                  handleMenuClose();
                }}
              >
                Assign YUVA EC
              </MenuItem>
            )}

            {/* Edit - always shown if not read-only */}
            {!isReadOnly && (
              <MenuItem
                onClick={() => {
                  navigate(
                    `/user/register/no_id?edit=true&id=${encodeURIComponent(
                      params.row.userId
                    )}?tab=${activeTab}`
                  );
                  handleMenuClose();
                }}
              >
                Edit
              </MenuItem>
            )}
          </Menu>
        </>
      ),
    },

  ];

  const rows = displayUsers.map((user, idx) => ({ ...user, id: idx + 1 }));

  // Elevate on hover component for cards
  const ElevateOnHover = ({ children }) => {
    const [hovered, setHovered] = useState(false);
    return (
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          borderRadius: 12,
          background: "#ffffff",
          transition: "box-shadow 200ms ease, transform 200ms ease",
          boxShadow: hovered
            ? "0 8px 24px rgba(16,24,40,.12)"
            : "0 1px 3px rgba(16,24,40,.06)",
          transform: hovered ? "translateY(-2px)" : "none",
        }}
      >
        {children}
      </div>
    );
  };

  // Stat Card Component
  const StatCard = ({ title, value, icon, gradient }) => (
    <ElevateOnHover>
      <div className={css.dashboardCard} style={{ overflow: "hidden" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
          }}
        >
          <h3
            className={css.cardTitle}
            style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}
          >
            {title}
          </h3>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: gradient,
              color: "#fff",
            }}
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
        <div
          className={css.cardContent}
          style={{ paddingTop: 0, padding: "0 16px 16px" }}
        >
          <div
            style={{ fontSize: "24px", fontWeight: "600", color: "#1f2937" }}
          >
            {value}
          </div>
        </div>
      </div>
    </ElevateOnHover>
  );

  const pageSizeOptions = [5, 10, 20, 50, 100, 7];

  function handleInstitutesClick() {
    navigate(`/user/register/${_id}`);
  }

  const loadOptions = async (inputValue, callback) => {
    try {
      const response = await axios.get(
        `${SERVER_ORIGIN}/api/institute/auth/institute/all?id=${_id}`,
        {
          params: {
            search: inputValue,
            page: 1,
            limit: 10,
            sortBy: "name",
            sortType: "asc",
            id: _id,
          },
        }
      );
      const options = response.data.filteredInstitutes.map((institute) => ({
        label: institute.name,
        value: institute._id,
        state: institute.state,
        city: institute.city,
      }));
      callback(options);
    } catch (error) {
      console.error("Error fetching institutes", error);
    }
  };

  return (
    <div className={css.outerDiv}>
      <div className={css.headerSection}>
        <div className={css.headerLeft}>
          <BackButton
            text="Back to Institutes"
            navigateTo={getManageInstitutePath()}
          // customPath={
          //   activeTab === "thalir"
          //     ? "/institutes/all?tab=thalir"
          //     : "/institutes/all?tab=institute"
          // }
          />
        </div>
      </div>

      {isReadOnly && (
        <div className={css.readOnlyAlert}>
          <div className="alert alert-info" role="alert">
            <strong>Read-Only Access:</strong> You can view all student data but
            cannot add, edit, or delete any records.
          </div>
        </div>
      )}

      {/* Dashboard Stats Section */}
      <div className="my-4">
        <SecCard>
          <Row className="g-4">
            <div
              className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
            >
              <div className={css.serviceName}>
                {activeTab === "institute"
                  ? "YUVA Students Data"
                  : "Thalir Students Data"}
              </div>

              <div className={css.headerRight}>
                {isInviteAllowed && !isReadOnly && (
                  <button
                    className={css.addBtn}
                    onClick={handleInstitutesClick}
                  >
                    <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
                    Add Student
                  </button>
                )}
              </div>
            </div>

            <Col md={6} lg={4} sm={12} xs={12}>
              <StatCard
                title="Total Students"
                value={stats.total}
                icon={faUserGraduate}
                gradient="linear-gradient(135deg,#6366f1,#8b5cf6)"
              />
            </Col>

            {activeTab === "thalir" && uploadedDataStudentsCount > 0 && (
              <Col md={6} lg={4} sm={12} xs={12}>
                <StatCard
                  title="From Uploaded Sheet Data"
                  value={uploadedDataStudentsCount}
                  icon={faFileExcel}
                  gradient="linear-gradient(135deg,#059669,#10b981)"
                />
              </Col>
            )}

            <Col md={6} lg={4} sm={12} xs={12}>
              <StatCard
                title="Onboarding Status"
                value={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Onboarded
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#2e7d32",
                        }}
                      >
                        {stats.onboarded}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Invited
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#f57c00",
                        }}
                      >
                        {stats.invited}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Pending
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#c62828",
                        }}
                      >
                        {stats.pending}
                      </span>
                    </div>
                  </div>
                }
                icon={faUserCheck}
                gradient="linear-gradient(135deg,#10b981,#34d399)"
              />
            </Col>
            {/* 
            <Col md={6} lg={3} sm={12} xs={12}>
              <StatCard
                title="YUVA EC Members"
                value={stats.yuvaEC}
                icon={faIdBadge}
                gradient="linear-gradient(135deg,#f59e0b,#f97316)"
              />
            </Col> */}

            <Col md={6} lg={4} sm={12} xs={12}>
              <StatCard
                title="Registration Types"
                value={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Public
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#007bff",
                        }}
                      >
                        {stats.publicRegistration}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Regular
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#6c757d",
                        }}
                      >
                        {stats.regularRegistration}
                      </span>
                    </div>
                  </div>
                }
                icon={faFileSignature}
                gradient="linear-gradient(135deg,#06b6d4,#3b82f6)"
              />
            </Col>
          </Row>

          {/* Student Management Tools */}
          {isInviteAllowed && !isReadOnly && (
            <div className="mt-4">
              <Row className="g-3">
                <Col md={4} sm={12}>
                  <div style={{ marginBottom: "0.8rem" }}>
                    <AsyncSelect
                      cacheOptions
                      loadOptions={loadOptions}
                      defaultOptions={defaultOptions}
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          setSelectedOption(selectedOption);
                        }
                      }}
                      value={selectedOption}
                      placeholder="Select / Search Institute"
                    />
                  </div>
                </Col>
                <Col md={4} sm={12}>
                  <FileUpload collegeName={selectedOption} />
                </Col>
                <Col md={4} sm={12}>
                  <DownloadExcel />
                </Col>
              </Row>
            </div>
          )}
        </SecCard>
      </div>

      {/* Search Section */}
      <div className={css.searchFiltersSection}>
        <div className={css.filtersContainer}>
          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Search Students</label>
            <div className={css.searchInputWrapper}>
              <input
                type="text"
                value={searchQuery}
                placeholder="Search from the list"
                onChange={(e) => setSearchQuery(e.target.value)}
                className={css.searchInput}
              />
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className={css.searchIcon}
              />
            </div>
          </div>
        </div>
      </div>

      {yuvaEcOnly && (
        <div className="alert alert-info mb-3" role="alert">
          Showing only students with <strong>YUVA EC assigned</strong> for this institute.
        </div>
      )}

      {activeTab === "thalir" && uploadedDataStudentsCount > 0 && (
        <div
          className="alert alert-info mb-3"
          role="alert"
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          <FontAwesomeIcon icon={faFileExcel} />
          <span>
            <strong>{uploadedDataStudentsCount}</strong> students count is coming from the uploaded Excel data for Thalir schools.
          </span>
        </div>
      )}

      {isLoading ? (
        <Loader />
      ) : (
        <div className={css.dataGridContainer}>
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            density="compact"
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            sx={{
              borderRadius: 2,
              border: "1px solid #e5e7eb",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f9fafb",
                color: "#111827",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#fcfcfd",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#eef2ff",
              },
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 300 },
              },
            }}
            loading={isLoading}
          />
        </div>
      )}

      <YuvaEcAssignmentModal
        show={showEcModal}
        onHide={() => setShowEcModal(false)}
        student={selectedStudent}
        onSuccess={() => {
          setRerender(!rerender);
        }}
      />
    </div>
  );
};

export default InstutueStudents;